import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { OptionStatus, Product } from '@dch/products-business-logic';
import { getNspOption, INspValues } from '../utils/nsp.utils';
import { isEmpty } from 'lodash';
import { Store } from '@ngrx/store';
import { UpdateMobileNspValues } from '../store/actions/nsp.actions';

@Component({
  selector: 'mprd-nsp-mobile-list-component',
  templateUrl: './nsp-mobile-list-component.component.html',
})
export class NspMobileListComponentComponent implements OnInit, OnChanges {
  @Input() products: Product[];
  @Output() hasChanged = new EventEmitter<boolean>();

  public switchesValues: INspValues = {};
  public initialSwitches: INspValues = {};
  public toggleAllValue = false;

  constructor(private store: Store) {}
  ngOnInit() {
    this.toggleAllValue = this.checkAllHaveSameValue(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.hasOwnProperty('products') &&
      JSON.stringify(changes.products.previousValue) !==
        JSON.stringify(changes.products.currentValue)
    ) {
      this.switchesValues = {};
      this.fillSwitchesValues(this.switchesValues);
      if (isEmpty(this.initialSwitches)) {
        this.fillSwitchesValues(this.initialSwitches);
      }
    }
  }

  private detectChanges(switches: INspValues) {
    for (const key of Object.keys(this.switchesValues)) {
      if (switches[key].value !== this.initialSwitches[key].value) {
        this.hasChanged.emit(true);
        break;
      }
      this.hasChanged.emit(false);
    }
  }

  private fillSwitchesValues(switchesValues: INspValues) {
    this.products?.forEach((product: Product) => {
      const option = getNspOption(product);
      if (option) {
        switchesValues[product.accessNumber] = {
          accessNumber: product.accessNumber,
          value: option.ibStatus === OptionStatus.ACTIVE,
          active: option.ibStatus === OptionStatus.ACTIVE,
          trialOption: option.trialOption,
          chargeConfiguration: product.chargeConfiguration,
          plc: product.plc,
          mpcUuid: option.optionCodeForDescription,
        };
      }
    });
    // init the store
    this.store.dispatch(new UpdateMobileNspValues(this.switchesValues));
  }

  public getNspSwitchesKeys() {
    return Object.keys(this.switchesValues);
  }

  public handleSwitch(accessNumber: string) {
    const newSwitchesValues: INspValues = { ...this.switchesValues };
    newSwitchesValues[accessNumber] = {
      ...newSwitchesValues[accessNumber],
      value: !this.switchesValues[accessNumber].value,
    };
    this.detectChanges(newSwitchesValues);
    this.switchesValues = newSwitchesValues;
    this.toggleAllValue = this.checkAllHaveSameValue(true);
    // update the store
    this.store.dispatch(new UpdateMobileNspValues(newSwitchesValues));
  }

  public setAllSwitches(newValue: boolean) {
    const newSwitchesValues: INspValues = { ...this.switchesValues };
    for (const accessNumber of Object.keys(this.switchesValues)) {
      newSwitchesValues[accessNumber] = {
        ...newSwitchesValues[accessNumber],
        value: newValue,
      };
    }
    this.detectChanges(newSwitchesValues);
    this.switchesValues = newSwitchesValues;
    this.toggleAllValue = newValue;
    this.store.dispatch(new UpdateMobileNspValues(newSwitchesValues));
  }

  public getToggleKey() {
    return this.toggleAllValue
      ? 'nsp.activationMobile.deactivateAll'
      : 'nsp.activationMobile.activateAll';
  }

  private checkAllHaveSameValue(value: boolean) {
    return !Object.keys(this.switchesValues).find(
      (accessNumber) => this.switchesValues[accessNumber].value !== value,
    );
  }
}
